import React, {Component} from 'react';
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {Rate} from 'antd'
import {reverseParseTextView} from './createRender';
import {message,Tooltip} from 'antd'
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';


const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        // val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
        e.stopPropagation();
        this.setState({visible: val});
    };
    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            })
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        this.delayImage();
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
        // 获取所有的图片
        let data = reverseParseTextView(this.props.data);
        this.props.getData && this.props.getData(data, 'hollow');
    }


    componentDidUpdate(prevProps, prevState) {
        // 获取所有的图片
        if (prevProps.data.question_id !== this.props.data.question_id) {
            let data = reverseParseTextView(this.props.data);
            this.props.getData && this.props.getData(data, 'hollow');
        }
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        this.delayImage();
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});

    delayImage = () => {
        if (!this.props.data) {
            return;
        }
        let blankImg = new Image();
        blankImg.src = 'http://knowapp.b0.upaiyun.com/ss/pcSide/fill_image_samll.png';
        setTimeout(() => {
            document.getElementsByName('questionFillImage').forEach((e) => {
                let img = new Image();
                img.onload = function () {
                    let ctx = e.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    let pos = JSON.parse(e.dataset.position);
                    let answer = e.dataset.answer == 'undefined' ? [] : e.dataset.answer.split(',');
                    if (answer.length !== 0) {
                        for (let key in pos) {
                            // ctx.drawImage(blankImg, pos[key].x_pos + 25, pos[key].y_pos + 7);
                            let height = 0,width=0;
                            if(pos[key].size=='img_blank'){
                                width=80
                                height=48
                            }
                            if(pos[key].size=='big_img_blank'){
                                width=160
                                height=48
                            }
                            if(pos[key].size=='small_img_blank'){
                                width=40
                                height=48
                            }
                            ctx.fillStyle='rgba(100, 100, 100, 0.5)';
                            ctx.fillRect(pos[key].x_pos,pos[key].y_pos,width,height);
                        }
                    }
                    answer.forEach((val, index) => {
                        ctx.font = "20px PingFangSC-Regular";
                        ctx.fillStyle='rgba(255, 255, 255, 1)';

                        ctx.fillText(val, pos[`imgBlankAnswer${index}`].x_pos+20, pos[`imgBlankAnswer${index}`].y_pos + 35);
                    })
                };
                img.onerror = function () {
                    message.error("网络错误")
                };
                img.src = e.dataset.image;
            })
        }, 500);
        setTimeout(() => {
            document.getElementsByName('question').forEach((img) => {
                img.setAttribute('crossOrigin', 'anonymous');
                img.onerror = function () {
                    message.error("网络错误")
                };
                img.src = img.dataset.src;
            })
        }, 500);
    };


    render() {
        const {visible} = this.state;

        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

        const {num, children} = this.props;
        let data = {};
        data = reverseParseTextView(originData);
        let difficulty = ['未知', '容易', '一般', '较难', '难'];
        if(data.answer==='答案解析错误'){
            message.error('答案格式错误，无法正常解析')
            data.answer = [];
        }
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    <div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(data.stem)}/>
                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span style={{fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    <span style={{fontSize: 14}}  dangerouslySetInnerHTML={this.createHtml(data.answer.join('、 '))}/>
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/hollow/viewForView.js